import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-zahlartkassa-data-view',
  imports: [CommonModule],
  templateUrl: './zahlartkassa.list-view.html',
  styleUrls: ['./zahlartkassa.list-view.scss'],
})
export class ZahlartkassaListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
